import React, { Component } from "react";
import ReactDOM from "react-dom";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import {
  CustomizedXAxisTickTime,
  CustomizedYAxisTick,
  selectFormat,
  Error,
  StandardTooltip,
  MAIN_COLORS,
  formatDateFromData,
} from "./../../Utils/Utils.js";

const createLabel = (key, value, color) => (
  <div className="standard-tooltip__item" key={key}>
    <span className="standard-tooltip__key">
      <span className="standard-tooltip__icon" style={{ background: color }} />
      {key}
    </span>
    <span className="standard-tooltip__value">
      {selectFormat("number", value)}
    </span>
  </div>
);

class SnapChatMultilineChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      networks: [],
      data: [],
    };
    this.colors = {};
    this.fieldProps = [];
  }

  componentDidMount() {
    this.props.childRef(this);

    this.initLoading = true;
    setTimeout(() => (this.initLoading = false), 1500); // animation duration in recharts lib
  }

  shouldComponentUpdate() {
    return !this.initLoading;
  }

  clickGraphLegend = (event) => {
    const value = event.value.props["data-name"];
    let arr = this.state.networks.slice(0);

    // // Legends
    const node = ReactDOM.findDOMNode(this.refs.social_graph);
    const list_elements = node.querySelectorAll(".recharts-legend-item");

    // Select clicked legend
    for (let i = 0; i < list_elements.length; i++) {
      if (list_elements[i].innerText === value) {
        list_elements[i]
          .querySelector(".recharts-symbols")
          .classList.toggle("recharts-symbols--off");
        list_elements[i]
          .querySelector(".recharts-legend-item-text")
          .classList.toggle("recharts-legend-item-text--off");
      }
    }

    // create an array of networks
    if (arr.indexOf(value) === -1) {
      arr.push(value);
    } else {
      arr.splice(arr.indexOf(value), 1);
    }

    this.setState({ networks: arr });
  };

  renderGraph = (data, series, networks) => {
    const filteredSeries = series.filter((s) => !networks.includes(s.name));
    return (
      <ResponsiveContainer height={300}>
        <LineChart
          height={300}
          data={data}
          margin={{
            top: 20,
            right: 0,
            left: 5,
            bottom: 0,
          }}
          ref="social_graph"
        >
          <Tooltip
            cursor={{ fill: "#eee", opacity: 0.5 }}
            content={
              <StandardTooltip
                render={({ data }) => {
                  const payload = data(this.props);
                  if (payload !== null) {
                    // create the labels based on each element from the payload
                    let labels = payload.map((p) =>
                      createLabel(p.dataKey, p.value, p.color)
                    );
                    let selected_date = payload[0].payload.date;

                    return (
                      <div className="standard-tooltip">
                        <header className="standard-tooltip__header">
                          <span className="standard-tooltip__key-header">
                            Date:
                          </span>
                          <span className="standard-tooltip__value-header">
                            {selected_date}
                          </span>
                        </header>
                        <main className="standard-tooltip__main">{labels}</main>
                      </div>
                    );
                  }
                }}
              />
            }
          />

          <CartesianGrid
            stroke="#FEE5DE"
            strokeDasharray="3 3"
            vertical={false}
          />

          <Legend
            verticalAlign="top"
            align="left"
            iconType="square"
            iconSize={15}
            height={65}
            onClick={this.clickGraphLegend}
            payload={series.map((s) => ({
              value: (
                <div
                  data-name={s.name}
                  style={{ display: "inline-block", marginRight: "5px" }}
                  data-tooltip-id="chart-icon-tooltip"
                  data-tooltip-html={s.name}
                >
                  {s.name}
                </div>
              ),
              color: s.color,
              type: "square",
            }))}
          />

          {filteredSeries.map((s) => (
            <Line
              key={s.name}
              type="monotone"
              dataKey={s.name}
              stroke={s.color}
              strokeWidth={2}
              dot={{ fill: s.color }}
              connectNulls={true}
            />
          ))}
          <XAxis
            dataKey="date"
            axisLine={false}
            tickLine={false}
            interval="preserveStartEnd"
            scale="point"
            tick={<CustomizedXAxisTickTime />}
          />
          <YAxis
            dataKey="xValue"
            axisLine={false}
            tickLine={false}
            mirror={true}
            tick={<CustomizedYAxisTick />}
          />
        </LineChart>
      </ResponsiveContainer>
    );
  };

  getExportData = () => ({
    data: this.props.data.byDay,
    opts: {
      type: "chart",
      date: {
        defined: true,
        format: "YYYY-MM-DD",
      },
      exclude: this.state.networks.length
        ? this.state.networks.concat(["date"])
        : null,
    },
  });

  render() {
    let graphData = this.props.data;

    if (!graphData.byDay) {
      return <Error minHeight={360} />;
    }

    const series = graphData.list.map((serie, i) => ({
      name: serie.series,
      color: MAIN_COLORS[i],
    }));

    const data = formatDateFromData(this.props.data.byDay);

    // define the MAX value from that will be set into the xAxis
    data.forEach((e) => {
      let xValue = 0;
      for (const key in e) {
        if (key !== "date")
          xValue = Number(e[key]) > xValue ? Number(e[key]) : xValue;
      }
      e.xValue = xValue;
    });

    return this.renderGraph(data, series, this.state.networks);
  }
}

export default SnapChatMultilineChart;
